var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-container"},[_c('div',[_c('strong',[_vm._v("t: ")]),_vm._v(" "+_vm._s(_vm.t))]),_c('div',[_c('strong',[_vm._v(" Date: ")]),_vm._v(_vm._s(_vm.formattedDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }